import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  Box,
  ListItemText,
} from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import { Link } from "react-router-dom";
import { firestore } from "../config/firebase";
import LogoutIcon from "@mui/icons-material/Logout";
import { collection, getDocs } from "firebase/firestore";
import { useAuth } from "../utils/authContext";
const drawerWidth = 240;

export default function Sidebar(props) {
  const { isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();
  const { window } = props;
  const [isClosing, setIsClosing] = React.useState(false);
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [selectedItem, setSelectedItem] = useState("");
  const [firebaseData, setFirebaseData] = useState([]);
  const [adminDetails, setAdminDetails] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
  });

  const handleDrawerClose = () => {
    setIsClosing(true);
    setMobileOpen(false);
  };

  const handleDrawerTransitionEnd = () => {
    setIsClosing(false);
  };

  useEffect(() => {
    if (firebaseData.length > 0 && selectedItem) {
      const selectedAdmin = firebaseData.find(
        (admin) => admin.id === selectedItem
      );
      if (selectedAdmin) {
        setAdminDetails({
          firstName: selectedAdmin.firstName || "",
          lastName: selectedAdmin.lastName || "",
          email: selectedAdmin.email || "",
          phone: selectedAdmin.phone || "",
        });
      }
    }
  }, [selectedItem, firebaseData]);

  // const handleAvatarClick = (admin) => {
  //   console.log("Selected admin:", admin);
  //   setSelectedItem(admin.id);
  //   setAdminDetails({
  //     firstName: admin.firstName || "",
  //     lastName: admin.lastName || "",
  //     email: admin.email || "",
  //     phone: admin.phone || "",
  //   });
  //   navigate("/admin");
  // };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const fetchDataFromFirestore = async () => {
    try {
      const querySnapshot = await getDocs(collection(firestore, "admin"));
      const data = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setFirebaseData(data);
    } catch (error) {
      console.error("Error fetching data from Firebase:", error);
    }
  };

  useEffect(() => {
    fetchDataFromFirestore();
  }, []);

  const myStyles = {
    width: "124px",
    height: "33.29px",
    top: "30px",
    left: "52px",
    position: "absolute",
    color: "white",
    objectFit: "cover",
  };

  const itemImages = {
    Dashboard: "/dashboard.svg",
    Counsellors: "/counsellor.svg",
    Users: "/user.svg",
    Universities: "/uni.svg",
    Posts: "/addpost.svg",
    Advertisements: "/addvertise.svg",
    SuccessStory: "/successstory.svg",
  };

  const drawer = (
    <Box className="sidebar">
      <Toolbar />

      <Box style={myStyles}>
        <img src={"/logo.svg"} alt="logo_image" />
        <img src={"/logo_name.svg"} alt="logo_image2" />
      </Box>

      <List style={{ alignItems: "center" }}>
        {Object.entries(itemImages).map(([text, imagePath]) => (
          <ListItem key={text} disablePadding>
            <ListItemButton
              component={Link}
              to={
                text === "Counsellors"
                  ? "/counsellorlist"
                  : text === "Dashboard"
                  ? "/"
                  : text === "Users"
                  ? "/userlist"
                  : text === "Posts"
                  ? "/posts"
                  : text === "Advertisements"
                  ? "/advertisements"
                  : text === "Universities"
                  ? "/university"
                  : "/success-story"
              }
              style={{
                color: selectedItem === text ? " #18407c" : "white",
                backgroundColor: selectedItem === text ? "white" : "",
                marginTop: text === "Notification" ? "240px" : "8px",
                borderRadius: "10px",
                display: "flex",
                marginLeft: "23px",
                marginRight: "23px",
                alignItems: "center",
                justifyContent: "center",
                alignItems: "center",
                fontSize: "16px",
                fontFamily: "Inter, sans-serif",
                fontWeight: "600",
              }}
              onClick={() => setSelectedItem(text)}
            >
              <ListItemIcon>
                <img
                  src={imagePath}
                  style={{
                    width: "24px",
                    height: "24px",
                    display: "block",
                    margin: "auto",
                    // color: "#18407c",
                    filter:
                      selectedItem === text
                        ? "brightness(0.8) invert(1) hue-rotate(15deg)"
                        : "",
                  }}
                />
              </ListItemIcon>
              <ListItemText primary={text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>

      <Box
        style={{
          position: "absoloute",
        }}
      >
        <Divider
          style={{
            width: "202px",
            height: "1px",
            marginLeft: "18px",
            backgroundColor: "rgba(217, 217, 217, 1)",
          }}
        />
        <>
          <List style={{}}>
            <ListItem disablePadding>
              <ListItemButton style={{}} onClick={() => logout()}>
                <ListItemIcon style={{}}>
                  <LogoutIcon style={{ color: "#fff" }} />
                </ListItemIcon>

                <ListItemText
                  style={{
                    color: "#fff",
                    fontSize: "30px",
                    fontFamily: "Inter, sans-serif",
                  }}
                  primary="Log Out"
                />
              </ListItemButton>
            </ListItem>
          </List>
        </>
      </Box>
    </Box>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return !isAuthenticated ? (
    <></>
  ) : (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />

      <Toolbar>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="start"
          onClick={handleDrawerToggle}
          sx={{ mr: 2, display: { sm: "none" } }}
        >
          <MenuIcon />
        </IconButton>
      </Toolbar>

      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="mailbox folders"
      >
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerClose}
          onTransitionEnd={handleDrawerTransitionEnd}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: "none", sm: "block" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          width: { sm: `calc(100% - ${drawerWidth}px)` },
        }}
      >
        <Toolbar />
      </Box>
    </Box>
  );
}
